@if(show)
{
<div class="notification-modal-overlay"></div>
<div class="notification-container">
  <span class="notification-text">{{brand()??"Our website"}} uses cookies to give you the best online experience. Strictly neccessary cookies are on by default. Additional cookies are off by default. <a href="/Privacy/#cookiesAndOtherTechnologies">Cookie policy</a></span>
  <div class="notification-button-container">
    <div class="notification-button">
      <a class="notification-link" (click)="closeAndAccept($event)">Accept additional cookies</a>
    </div>
    <div class="notification-button">
      <a class="notification-link" (click)="closeAndReject($event)">Reject additional cookies</a>
    </div>
  </div>
</div>
}
